/**
 * Leaves the application for another site (the Google consent screen). It is
 * a function of its own so that a test can replace it: jsdom does not allow a
 * test to watch `window.location`.
 */
export function leaveTo(url: string): void {
  window.location.assign(url)
}
